export default "__VITE_PUBLIC_ASSET__d642b90b__"